
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 532 532","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Wesbite","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Artboard-Copy","transform":"translate(-852 -2301)"}},[_c('g',{attrs:{"id":"Group-12","transform":"translate(707 2301)"}},[_c('g',{attrs:{"id":"Group-17","transform":"translate(145)"}},[_c('circle',{attrs:{"id":"Oval","fill":"#465382","cx":"266","cy":"266","r":"266"}}),_c('circle',{attrs:{"id":"Oval","fill":"#F9D5E0","cx":"391.5","cy":"140.5","r":"140.5"}})])])])])])
          )
        }
      }
    